var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotifyBig = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M60 20a2 2 0 0 0-2 2v6.17C49.163 29.448 42 36.975 42 46v20l-8 8v4h52v-4l-8-8V46c0-9.026-7.163-16.553-16-17.83V22a2 2 0 0 0-2-2M54 84a6 6 0 0 0 12 0z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 75,
  cy: 35,
  r: 10,
  fill: "red"
})));
export default SvgNotifyBig;